var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      staticStyle: { top: "20px", height: "95%" },
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        keyboard: false,
        forceRender: true,
        prefixNo: _vm.prefixNo,
        fullscreen: "",
        switchHelp: "",
        switchFullscreen: "",
        id: _vm.prefixNo,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
          _vm.billPrintFlag && _vm.isShowPrintBtn
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handlePrintPro("零售出库")
                    },
                  },
                },
                [_vm._v("三联打印-新版")]
              )
            : _vm._e(),
          _vm.billPrintFlag && _vm.isShowPrintBtn
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handlePrint("零售出库")
                    },
                  },
                },
                [_vm._v("三联打印")]
              )
            : _vm._e(),
          _vm.checkFlag && _vm.isCanCheck
            ? _c(
                "a-button",
                {
                  attrs: { loading: _vm.confirmLoading },
                  on: { click: _vm.handleOkAndCheck },
                },
                [_vm._v("保存并审核")]
              )
            : _vm._e(),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleOkOnly },
            },
            [_vm._v("保存（Ctrl+S）")]
          ),
          !_vm.checkFlag
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleWorkflow()
                    },
                  },
                },
                [_vm._v("提交流程")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "会员卡号",
                            "data-step": "1",
                            "data-title": "会员卡号",
                            "data-intro":
                              "如果发现需要选择的会员卡号尚未录入，可以在下拉框中点击新增会员信息进行录入",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["organId"],
                                  expression: "[ 'organId' ]",
                                },
                              ],
                              attrs: {
                                placeholder: "请选择会员卡号",
                                dropdownMatchSelectWidth: false,
                                showSearch: "",
                                optionFilterProp: "children",
                              },
                              on: {
                                change: _vm.onChangeOrgan,
                                search: _vm.handleSearchRetail,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "dropdownRender",
                                  fn: function (menu) {
                                    return _c(
                                      "div",
                                      {},
                                      [
                                        _c("v-nodes", {
                                          attrs: { vnodes: menu },
                                        }),
                                        _c("a-divider", {
                                          staticStyle: { margin: "4px 0" },
                                        }),
                                        _vm.quickBtn.member
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-btn",
                                                on: {
                                                  mousedown: (e) =>
                                                    e.preventDefault(),
                                                  click: _vm.addMember,
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "plus" },
                                                }),
                                                _vm._v(" 新增会员"),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-btn",
                                            on: {
                                              mousedown: (e) =>
                                                e.preventDefault(),
                                              click: function ($event) {
                                                return _vm.initRetail(0)
                                              },
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "reload" },
                                            }),
                                            _vm._v(" 刷新列表"),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  },
                                },
                              ]),
                            },
                            _vm._l(_vm.retailList, function (item, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.supplier) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据日期",
                          },
                        },
                        [
                          _c("j-date", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "operTime",
                                  _vm.validatorRules.operTime,
                                ],
                                expression:
                                  "['operTime', validatorRules.operTime]",
                              },
                            ],
                            attrs: { "show-time": true },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据编号",
                            "data-step": "2",
                            "data-title": "单据编号",
                            "data-intro":
                              "单据编号自动生成、自动累加、开头是单据类型的首字母缩写，累加的规则是每次打开页面会自动占用一个新的编号",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["number", _vm.validatorRules.number],
                                expression:
                                  "[ 'number', validatorRules.number ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入单据编号" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "收款类型",
                            "data-step": "3",
                            "data-title": "收款类型",
                            "data-intro":
                              "收款类型可以有现付和预付款两种类型，当选择了会员之后，如果该会员有预付款，在此处会显示具体预付款的金额，而且系统会优先默认选中预付款",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["payType"],
                                  expression: "[ 'payType' ]",
                                },
                              ],
                              attrs: {
                                placeholder: "请选择付款类型",
                                dropdownMatchSelectWidth: false,
                              },
                            },
                            _vm._l(_vm.payTypeList, function (item, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: item.value } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.text) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 18, md: 12, sm: 24 } },
                    [
                      _c("j-editable-table", {
                        ref: _vm.refKeys[0],
                        attrs: {
                          id: "billModal",
                          loading: _vm.materialTable.loading,
                          columns: _vm.materialTable.columns,
                          dataSource: _vm.materialTable.dataSource,
                          minWidth: _vm.minWidth,
                          maxHeight: 300,
                          rowNumber: false,
                          rowSelection: true,
                          actionButton: true,
                          dragSortAndNumber: true,
                        },
                        on: {
                          valueChange: _vm.onValueChange,
                          added: _vm.onAdded,
                          deleted: _vm.onDeleted,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "buttonAfter",
                            fn: function () {
                              return [
                                _c(
                                  "a-row",
                                  {
                                    staticStyle: { float: "left" },
                                    attrs: {
                                      gutter: 24,
                                      "data-step": "4",
                                      "data-title": "扫码录入",
                                      "data-intro":
                                        "此功能支持扫码枪扫描商品条码进行录入",
                                    },
                                  },
                                  [
                                    _vm.scanStatus
                                      ? _c(
                                          "a-col",
                                          { attrs: { md: 6, sm: 24 } },
                                          [
                                            _c(
                                              "a-button",
                                              { on: { click: _vm.scanEnter } },
                                              [_vm._v("扫码录入")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !_vm.scanStatus
                                      ? _c(
                                          "a-col",
                                          {
                                            staticStyle: {
                                              padding: "0 6px 0 12px",
                                            },
                                            attrs: { md: 16, sm: 24 },
                                          },
                                          [
                                            _c("a-input", {
                                              ref: "scanBarCode",
                                              attrs: {
                                                placeholder:
                                                  "请扫条码或序列号并回车",
                                              },
                                              on: {
                                                pressEnter: _vm.scanPressEnter,
                                              },
                                              model: {
                                                value: _vm.scanBarCode,
                                                callback: function ($$v) {
                                                  _vm.scanBarCode = $$v
                                                },
                                                expression: "scanBarCode",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !_vm.scanStatus
                                      ? _c(
                                          "a-col",
                                          {
                                            staticStyle: {
                                              padding: "0px 18px 0 0",
                                            },
                                            attrs: { md: 6, sm: 24 },
                                          },
                                          [
                                            _c(
                                              "a-button",
                                              { on: { click: _vm.stopScan } },
                                              [_vm._v("收起扫码")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "depotBatchSet",
                            fn: function () {
                              return [
                                _c("a-icon", {
                                  attrs: { type: "down" },
                                  on: { click: _vm.handleBatchSetDepot },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "depotAdd",
                            fn: function () {
                              return [
                                _vm.quickBtn.depot
                                  ? _c("a-divider", {
                                      staticStyle: { margin: "4px 0" },
                                    })
                                  : _vm._e(),
                                _vm.quickBtn.depot
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "dropdown-btn",
                                        on: { click: _vm.addDepot },
                                      },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "plus" },
                                        }),
                                        _vm._v(" 新增"),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-btn",
                                    on: {
                                      mousedown: (e) => e.preventDefault(),
                                      click: _vm.initDepot,
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "reload" } }),
                                    _vm._v(" 刷新"),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { lg: 24, md: 24, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: {
                                      xs: { span: 24 },
                                      sm: { span: 24 },
                                    },
                                    label: "",
                                  },
                                },
                                [
                                  _c("a-textarea", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: ["remark"],
                                        expression: "[ 'remark' ]",
                                      },
                                    ],
                                    staticStyle: { "margin-top": "8px" },
                                    attrs: {
                                      rows: 1,
                                      placeholder: "请输入备注",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "附件",
                                    "data-step": "9",
                                    "data-title": "附件",
                                    "data-intro":
                                      "可以上传与单据相关的图片、文档，支持多个文件",
                                  },
                                },
                                [
                                  _c("j-upload", {
                                    attrs: { bizPath: "bill" },
                                    model: {
                                      value: _vm.fileList,
                                      callback: function ($$v) {
                                        _vm.fileList = $$v
                                      },
                                      expression: "fileList",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "sign" },
                    [
                      _c(
                        "a-col",
                        { attrs: { lg: 6, md: 12, sm: 24 } },
                        [
                          _c(
                            "a-row",
                            { staticClass: "form-row", attrs: { gutter: 24 } },
                            [
                              _c("a-col", { attrs: { lg: 24, md: 6, sm: 6 } }, [
                                _c("br"),
                                _c("br"),
                              ]),
                              _c(
                                "a-col",
                                { attrs: { lg: 24, md: 6, sm: 6 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol,
                                        "data-step": "5",
                                        "data-title": "单据金额",
                                        "data-intro":
                                          "单据金额等于左侧商品的总金额",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "20px",
                                            "line-height": "20px",
                                          },
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("单据金额")]
                                      ),
                                      _c("a-input", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator.trim",
                                            value: ["changeAmount"],
                                            expression: "[ 'changeAmount' ]",
                                            modifiers: { trim: true },
                                          },
                                        ],
                                        style: { color: "purple" },
                                        attrs: { readOnly: true },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { lg: 24, md: 6, sm: 6 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol,
                                        "data-step": "6",
                                        "data-title": "收款金额",
                                        "data-intro":
                                          "收款金额为收银员收取用户的实际金额",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "20px",
                                            "line-height": "20px",
                                          },
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("收款金额")]
                                      ),
                                      _c("a-input", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator.trim",
                                            value: ["getAmount"],
                                            expression: "[ 'getAmount' ]",
                                            modifiers: { trim: true },
                                          },
                                        ],
                                        style: { color: "red" },
                                        attrs: { defaultValue: "0" },
                                        on: { change: _vm.onChangeGetAmount },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { lg: 24, md: 6, sm: 6 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol,
                                        "data-step": "7",
                                        "data-title": "找零",
                                        "data-intro":
                                          "找零等于收款金额减去实收金额",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "20px",
                                            "line-height": "20px",
                                          },
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("找零")]
                                      ),
                                      _c("a-input", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator.trim",
                                            value: ["backAmount"],
                                            expression: "[ 'backAmount' ]",
                                            modifiers: { trim: true },
                                          },
                                        ],
                                        style: { color: "green" },
                                        attrs: {
                                          readOnly: true,
                                          defaultValue: "0",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { lg: 24, md: 6, sm: 6 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol,
                                        "data-step": "8",
                                        "data-title": "收款账户",
                                        "data-intro":
                                          "收款账户的信息来自基本资料菜单下的【结算账户】",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "20px",
                                            "line-height": "20px",
                                          },
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v("收款账户")]
                                      ),
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "accountId",
                                                _vm.validatorRules.accountId,
                                              ],
                                              expression:
                                                "[ 'accountId', validatorRules.accountId ]",
                                            },
                                          ],
                                          staticStyle: { "font-size": "20px" },
                                          attrs: {
                                            placeholder: "请选择收款账户",
                                            dropdownMatchSelectWidth: false,
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "dropdownRender",
                                              fn: function (menu) {
                                                return _c(
                                                  "div",
                                                  {},
                                                  [
                                                    _c("v-nodes", {
                                                      attrs: { vnodes: menu },
                                                    }),
                                                    _c("a-divider", {
                                                      staticStyle: {
                                                        margin: "4px 0",
                                                      },
                                                    }),
                                                    _vm.quickBtn.account
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-btn",
                                                            on: {
                                                              mousedown: (e) =>
                                                                e.preventDefault(),
                                                              click:
                                                                _vm.addAccount,
                                                            },
                                                          },
                                                          [
                                                            _c("a-icon", {
                                                              attrs: {
                                                                type: "plus",
                                                              },
                                                            }),
                                                            _vm._v(" 新增"),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dropdown-btn",
                                                        on: {
                                                          mousedown: (e) =>
                                                            e.preventDefault(),
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.initAccount(
                                                              0
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("a-icon", {
                                                          attrs: {
                                                            type: "reload",
                                                          },
                                                        }),
                                                        _vm._v(" 刷新"),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              },
                                            },
                                          ]),
                                        },
                                        _vm._l(
                                          _vm.accountList,
                                          function (item, index) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: index,
                                                attrs: { value: item.id },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.name) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("member-modal", {
        ref: "memberModalForm",
        on: { ok: _vm.memberModalFormOk },
      }),
      _c("depot-modal", {
        ref: "depotModalForm",
        on: { ok: _vm.depotModalFormOk },
      }),
      _c("account-modal", {
        ref: "accountModalForm",
        on: { ok: _vm.accountModalFormOk },
      }),
      _c("batch-set-depot", {
        ref: "batchSetDepotModalForm",
        on: { ok: _vm.batchSetDepotModalFormOk },
      }),
      _c("workflow-iframe", {
        ref: "modalWorkflow",
        on: { ok: _vm.workflowModalFormOk },
      }),
      _c("bill-print-iframe", { ref: "modalPrint" }),
      _c("bill-print-pro-iframe", { ref: "modalPrintPro" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }